// @flow

import { deleteRaw, patchRaw } from './api.core'

export const remove = params => deleteRaw('api/mass_action/', params)
export const updateRequest = params => patchRaw('api/mass_action/', params)
